var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{attrs:{"id":"contact"}},[_c('div',{staticClass:"footer-content"},[_c('p',{staticClass:"copyright"},[_vm._v(" Copyright@ 2021 Shanhaixingyu-CopyrightRadio and Television Program Production License: (Guinan) No. 00075Network Culture Operation License:Gui.com.cn(2023)0255-0801 Telecommunications Business License:Gui B2-20230098 ")])])])
}]

export { render, staticRenderFns }